import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { useContentStyles } from './styles';
import ProgressContent from './ProgressContent';
import { formatBillingStatusDisplayText } from './util';

const ProgressMoveTimeStep = ({
  batchId,
  timeEntrySummary,
  moveTimeData,
  onBatchComplete
}) => {
  const classes = useContentStyles();
  const { formatMessage } = useIntl();

  const movingEntriesValues = useMemo(
    () => ({
      count: timeEntrySummary.count,
      hours: timeEntrySummary.totalHours,
      bold: chunks => <strong>{chunks}</strong>
    }),
    [timeEntrySummary.count, timeEntrySummary.totalHours]
  );

  return (
    <div className={classes.stepContent}>
      <Box className={classes.summaryBox}>
        <Typography variant="body1">
          <FormattedMessage
            id="moveTimeDialog.movingTimeEntriesDescription"
            values={movingEntriesValues}
          />
        </Typography>
        <div className={classes.detailRow}>
          <Typography variant="body1" className={classes.detailLabel}>
            <FormattedMessage id="moveTimeDialog.from" />:
          </Typography>
          <Typography variant="body1" className={classes.fromLabel}>
            {moveTimeData.source.project?.displayText} /{' '}
            {moveTimeData.source.task?.fullPathText ||
              moveTimeData.source.task?.displayText}
          </Typography>
        </div>
        <div className={classes.detailRow}>
          <Typography variant="body1" className={classes.detailLabel}>
            <FormattedMessage id="moveTimeDialog.to" />:
          </Typography>
          <Typography variant="body1" className={classes.toLabel}>
            {moveTimeData.destination.project?.displayText} /{' '}
            {moveTimeData.destination.task?.fullPathText ||
              moveTimeData.destination.task?.displayText}
          </Typography>
        </div>
        <div className={classes.detailRow}>
          <Typography variant="body1" className={classes.detailLabel} />
          <Typography variant="body1" className={classes.billingStatusLabel}>
            {formatBillingStatusDisplayText(
              moveTimeData.billingStatus,
              formatMessage
            )}
          </Typography>
        </div>
      </Box>
      <Box mt={3}>
        <ProgressContent
          batchId={batchId}
          itemCounts={timeEntrySummary.count}
          onBatchComplete={onBatchComplete}
        />
      </Box>
    </div>
  );
};

ProgressMoveTimeStep.propTypes = {
  batchId: PropTypes.string,
  timeEntrySummary: PropTypes.object.isRequired,
  moveTimeData: PropTypes.object.isRequired,
  onBatchComplete: PropTypes.func.isRequired
};

export default ProgressMoveTimeStep;
